import type { StepKeyResultValues } from './Evaluation/types';

const NO_TASK_FILTER = '';
const ONLY_NOT_EVALUATED = false;

const ALL_REPORTS_LIMIT = 100;
export const FIRST_PAGE_OFFSET = 1;
export const FIRST_PAGE_INDEX = 0;
export const COMMENT_DEBOUNCE_MS = 1000;
export const SUMMARY_COMMENT_DEBOUNCE_MS = 1200;
export const DEFAULT_LOCALE = 'en-US';
export const EMPTY_TEXT = '';
export const DEFAULT_TASK_TIME_FORMAT = 'seconds';
export const DECIMAL_COMMA = ',';
export const DECIMAL_DOT = '.';
export const EMPTY_STEP_FIELD = 'empty_step';
export const EMPTY_TASK_RPN = 0;

export const ALL_REPORTS_FILTER = {
	limit: ALL_REPORTS_LIMIT,
	offset: FIRST_PAGE_OFFSET,
	only_not_evaluated: ONLY_NOT_EVALUATED,
	task_name: NO_TASK_FILTER
};

export const EMPTY_JOB_ELEMENT = '';

export const EMPTY_STEP_KEY_VALUES: StepKeyResultValues = {
	stress_level_id: null,
	frequency_id: null,
	total_task_duration_id: null,
	job_element: EMPTY_JOB_ELEMENT,
	task_rpn: EMPTY_TASK_RPN
};

export const SECTION = {
	BERA: 'bera',
	ENS: 'ens',
	ACTION_PLANS: 'action_plans'
} as const;

export const PATCHED_BANNER = 'The TLIDs with a new video must be re-evaluated.';
export const EDIT_ALL_BANNER = 'Press and drag the TLID stretches on the timeline or on the list to reorder them';
export const UNEVALUATED_MESSAGE = 'There are unevaluated TLIDs. Complete the evaluation to proceed.';
export const UNCOVERABLE_GAP_BANNER =
	'The remaining gap is too short for a new stretch, extend a neighbouring stretch to cover the interval.';
